// Shared bar renderer for the live (recording) and playback waveforms, so
// both look identical: rounded bars centred on the middle line, older bars
// (left) fading, newest (right) full strength.
export const BARS = 36;
export const BAR_SECONDS = 0.07; // one bar per 70ms: a calm, readable scroll

export function setupCanvas(canvas) {
  const dpr = window.devicePixelRatio || 1;
  const w = canvas.clientWidth;
  const h = canvas.clientHeight;
  canvas.width = Math.round(w * dpr);
  canvas.height = Math.round(h * dpr);
  const ctx = canvas.getContext('2d');
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  const color = getComputedStyle(canvas).getPropertyValue('color') || '#7B6CE6';
  return {ctx, w, h, color};
}

export function drawBars({ctx, w, h, color}, levels) {
  ctx.clearRect(0, 0, w, h);
  ctx.fillStyle = color;
  const n = levels.length;
  const gap = 4;
  const barW = (w - gap * (n - 1)) / n;
  const r = barW / 2;
  for (let i = 0; i < n; i++) {
    ctx.globalAlpha = 0.35 + 0.65 * (i / (n - 1));
    const bh = Math.max(barW, levels[i] * h);
    const x = i * (barW + gap);
    const y = (h - bh) / 2;
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + barW, y, x + barW, y + bh, r);
    ctx.arcTo(x + barW, y + bh, x, y + bh, r);
    ctx.arcTo(x, y + bh, x, y, r);
    ctx.arcTo(x, y, x + barW, y, r);
    ctx.fill();
  }
  ctx.globalAlpha = 1;
}
